import createIcon from '../../createIcon';

/**
 * @component @name More
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgM0g3QzYuMzEgMyA1Ljc3IDMuMzUgNS40MSAzLjg4TDAgMTJMNS40MSAyMC4xMUM1Ljc3IDIwLjY0IDYuMzggMjEgNy4wNyAyMUgyMkMyMy4xIDIxIDI0IDIwLjEgMjQgMTlWNUMyNCAzLjkgMjMuMSAzIDIyIDNaTTkgMTMuNUM4LjE3IDEzLjUgNy41IDEyLjgzIDcuNSAxMkM3LjUgMTEuMTcgOC4xNyAxMC41IDkgMTAuNUM5LjgzIDEwLjUgMTAuNSAxMS4xNyAxMC41IDEyQzEwLjUgMTIuODMgOS44MyAxMy41IDkgMTMuNVpNMTQgMTMuNUMxMy4xNyAxMy41IDEyLjUgMTIuODMgMTIuNSAxMkMxMi41IDExLjE3IDEzLjE3IDEwLjUgMTQgMTAuNUMxNC44MyAxMC41IDE1LjUgMTEuMTcgMTUuNSAxMkMxNS41IDEyLjgzIDE0LjgzIDEzLjUgMTQgMTMuNVpNMTkgMTMuNUMxOC4xNyAxMy41IDE3LjUgMTIuODMgMTcuNSAxMkMxNy41IDExLjE3IDE4LjE3IDEwLjUgMTkgMTAuNUMxOS44MyAxMC41IDIwLjUgMTEuMTcgMjAuNSAxMkMyMC41IDEyLjgzIDE5LjgzIDEzLjUgMTkgMTMuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const More = createIcon('More', [
  [
    'path',
    {
      d: 'M22 3H7C6.31 3 5.77 3.35 5.41 3.88L0 12L5.41 20.11C5.77 20.64 6.38 21 7.07 21H22C23.1 21 24 20.1 24 19V5C24 3.9 23.1 3 22 3ZM9 13.5C8.17 13.5 7.5 12.83 7.5 12C7.5 11.17 8.17 10.5 9 10.5C9.83 10.5 10.5 11.17 10.5 12C10.5 12.83 9.83 13.5 9 13.5ZM14 13.5C13.17 13.5 12.5 12.83 12.5 12C12.5 11.17 13.17 10.5 14 10.5C14.83 10.5 15.5 11.17 15.5 12C15.5 12.83 14.83 13.5 14 13.5ZM19 13.5C18.17 13.5 17.5 12.83 17.5 12C17.5 11.17 18.17 10.5 19 10.5C19.83 10.5 20.5 11.17 20.5 12C20.5 12.83 19.83 13.5 19 13.5Z',
      key: '1n8edl',
    },
  ],
]);

export default More;
